import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import recipientsTableConfig from '../constants/recipients_table_config';
import { searchNotificationsAction } from '../redux/index';
import Table from '../../../../../../../../../common/components/table/components/Table';

const RecipientsTable = props => {
  const { notificationId } = props;
  const { getDataRequestBody } = recipientsTableConfig;
  const mappedRequest = () => {
    return { ...getDataRequestBody(), notificationId };
  };
  return (
    <Table
      {...props}
      config={{
        ...recipientsTableConfig,
        getDataRequestBody: mappedRequest,
        headerConfig: { ...recipientsTableConfig.headerConfig, notificationId },
      }}
    />
  );
};

RecipientsTable.propTypes = {
  schema: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  isFetchingData: PropTypes.bool.isRequired,
  getDataBegin: PropTypes.func.isRequired,
  clearData: PropTypes.func.isRequired,
  notificationId: PropTypes.string.isRequired,
};

const mapStateToProps = state => {
  return {
    schema: get(state, 'entities.schemas.data.pages.notifications.recipients', []) || [],
    data: get(state, 'entities.notifications.searchNotifications.data', {}) || {},
    totalResultCount:
      get(state, 'entities.notifications.searchNotifications.data.totalResultCount', 0) || 0,
    isFetchingData:
      get(state, 'entities.notifications.searchNotifications.isFetching', false) || false,
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getDataBegin: searchNotificationsAction.BEGIN,
      clearData: searchNotificationsAction.CLEAR,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(RecipientsTable);
